// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
  const offcanvasCart = document.querySelector("#offcanvas-cart");
  const cartPage = document.querySelector("#cart");

  offcanvasCart?.classList.add("loading");
  cartPage?.classList.add("loading");

  const newResponse = await fetch(window.location.href);
  const text = await newResponse.text();
  const newDocument = new DOMParser().parseFromString(text, "text/html");

  offcanvasCart?.querySelector(".offcanvas-body").replaceWith(newDocument.querySelector("#offcanvas-cart .offcanvas-body"));
  offcanvasCart?.querySelector(".offcanvas-footer").replaceWith(newDocument.querySelector("#offcanvas-cart .offcanvas-footer"));
  cartPage?.replaceWith(newDocument.querySelector("#cart"));

  // Additional code from the second definition
  const combinedProtection = offcanvasCart?.querySelector("#combined-shipping-protection");
  const newCombinedProtection = newDocument.querySelector("#offcanvas-cart #combined-shipping-protection");
  if (combinedProtection && newCombinedProtection) {
    combinedProtection.replaceWith(newCombinedProtection);
  }

  document.querySelectorAll(".cart-count-badge").forEach((badge) => {
    badge.textContent = newDocument.querySelector(".cart-count-badge").textContent;
    badge.removeAttribute("hidden");
  });

  offcanvasCart?.classList.remove("loading");
  cartPage?.classList.remove("loading");

  window.dispatchEvent(new Event("updated.ecomify.cart"));
};

// Quantity Inputs
window.onChangeCartQty = async (input) => {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: input.dataset.lineItemKey,
      quantity: input.value,
    }),
  });
  window.refreshCartContents(response);
};

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: btn.dataset.lineItemKey,
      quantity: 0,
    }),
  });
  window.refreshCartContents(response);
};

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
  btn.innerHTML = `
          <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
              <span class="visually-hidden">Loading...</span>
          </div>
      `;

  const note = btn.closest("#cart-note").querySelector('[name="note"]').value;

  await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note }),
  });

  btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`;

  setTimeout(() => {
    btn.innerHTML = btn.dataset.textBtnSave;
  }, 4000);
};

// Checkout button - indicate loading on click and send Spotify event
window.onClickCheckoutBtn = (btn, event) => {
  // Prevent default form submission to allow time for Spotify event
  if (event) {
    event.preventDefault();
  }

  btn.style.height = btn.clientHeight + "px";
  btn.innerHTML = `
          <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
              <span class="visually-hidden">Loading...</span>
          </div>
      `;

  const cartTotal = parseFloat(btn.dataset.cartTotal) || 0;
  const cartCurrency = btn.dataset.cartCurrency || "USD";
  const cartItems = parseInt(btn.dataset.cartItems) || 0;

  const redirectToCheckout = () => {
    const form = btn.closest("form");
    if (form) {
      form.action = "/checkout";
      form.submit();
    }
  };

  if (window.spdt) {
    let hasRedirected = false;

    const safeRedirect = () => {
      if (!hasRedirected) {
        hasRedirected = true;
        redirectToCheckout();
      }
    };

    try {
      const maxTimeout = setTimeout(() => {
        safeRedirect();
      }, 1500);

      window.spdt("checkout", {
        value: cartTotal,
        currency: cartCurrency,
        event_id: "checkout_" + Date.now(),
      });

      setTimeout(() => {
        clearTimeout(maxTimeout);
        safeRedirect();
      }, 800);
    } catch (error) {
      console.error("Spotify Pixel error:", error);
      safeRedirect();
    }
  } else {
    redirectToCheckout();
  }
};

// Cart Goal - Use the new animated function from cart-goal.liquid
window.addEventListener("updated.ecomify.cart", () => {
  if (typeof window.animateCartGoalBar === "function") {
    setTimeout(window.animateCartGoalBar, 100);
  }
});

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
  const card = document.querySelector("#cart-summary");

  if (!card) return;

  if (window.matchMedia("max-width: 991px").matches) return;

  const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0;
  const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0;

  card.style.position = "sticky";
  card.style.top = `${navbarHeight + announcementBarHeight + 20}px`;
};
initStickySummaryCard();

window.addEventListener("updated.ecomify.cart", () => {
  initStickySummaryCard();
});

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
  btn.innerHTML = `
          <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
              <span class="visually-hidden">Loading...</span>
          </div>
      `;

  const wrapper = document.querySelector("#cart-shipping-rates-collapse");

  wrapper.querySelector("#shipping-rates-modal-alert-danger").innerHTML = "";
  wrapper.querySelector("#shipping-rates-modal-alert-danger").setAttribute("hidden", "hidden");
  wrapper.querySelector("#shipping-rates-modal-alert-warning").innerHTML = "";
  wrapper.querySelector("#shipping-rates-modal-alert-warning").setAttribute("hidden", "hidden");
  wrapper.querySelector("#shipping-rates-modal-alert-success").innerHTML = "";
  wrapper.querySelector("#shipping-rates-modal-alert-success").setAttribute("hidden", "hidden");

  const country = wrapper.querySelector("#shipping-rates-modal-country").value;
  const province = wrapper.querySelector("#shipping-rates-modal-province").value;
  const zip = wrapper.querySelector("#shipping-rates-modal-zip").value;

  const prepareResponse = await fetch(
    `/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
    {
      method: "POST",
    }
  );

  if (prepareResponse.ok) {
    const asyncRespose = await fetch(
      `/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
    );

    const data = await asyncRespose.json();

    let html = "";

    if (data.shipping_rates.length) {
      data.shipping_rates.forEach((elem) => {
        html += `
                      <li>
                          <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                      </li>
                  `;
      });

      wrapper.querySelector("#shipping-rates-modal-alert-success").innerHTML = `
                  <ul class="ps-5 mb-0">
                      ${html}
                  </ul>
              `;
      wrapper.querySelector("#shipping-rates-modal-alert-success").removeAttribute("hidden");
    } else {
      wrapper.querySelector("#shipping-rates-modal-alert-warning").innerHTML = `
                  <p class="mb-0">
                      ${wrapper.dataset.textNoResults}
                  </p>
              `;
      wrapper.querySelector("#shipping-rates-modal-alert-warning").removeAttribute("hidden");
    }
  } else {
    const data = await prepareResponse.json();

    let html = "";

    for (const [key, value] of Object.entries(data)) {
      html += `
                  <li>
                      <strong>${key}</strong>: ${value.toString()}
                  </li>
              `;
    }

    wrapper.querySelector("#shipping-rates-modal-alert-danger").innerHTML = `
              <ul class="ps-5 mb-0">
                  ${html}
              </ul>
          `;
    wrapper.querySelector("#shipping-rates-modal-alert-danger").removeAttribute("hidden");
  }

  btn.innerHTML = btn.dataset.text;
};

// Offcanvas cart - fix scrolling for callapses
const fixScrollingOffcanvasCollapses = () => {
  document.querySelectorAll('#offcanvas-cart [data-bs-toggle="collapse"]').forEach((elem) => {
    elem.addEventListener("click", () => {
      setTimeout(() => {
        const offcanvasBody = document.querySelector("#offcanvas-cart .offcanvas-body");
        offcanvasBody.scroll({ top: offcanvasBody.scrollHeight, behavior: "smooth" });
      }, 250);
    });
  });
};
fixScrollingOffcanvasCollapses();

window.addEventListener("updated.ecomify.cart", () => {
  fixScrollingOffcanvasCollapses();
});

// Upgrade to subscription
window.onChangeCartUpgradeToSub = async (select) => {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: select.dataset.lineItemKey,
      quantity: 0,
    }),
  });

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [
        {
          quantity: Number(select.dataset.quantity),
          id: Number(select.dataset.variantId),
          selling_plan: Number(select.value),
        },
      ],
    }),
  });

  window.refreshCartContents(response);
};

// Gift Wrap
window.onChangeCartGiftWrap = async (input) => {
  let response;

  if (input.checked) {
    response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: Number(input.value),
          },
        ],
      }),
    });
  } else {
    response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: input.dataset.lineItemKey,
        quantity: 0,
      }),
    });
  }
  window.refreshCartContents(response);
};

// Cart Min Order
const initCartMinOrder = () => {
  const wrapper = document.querySelector("#cart-min-order");
  if (!wrapper) return;

  if (wrapper.dataset.goalReached === "false") {
    wrapper.closest("form").querySelector(".btn-checkout").disabled = true;
  }
};
initCartMinOrder();
window.addEventListener("updated.ecomify.cart", () => {
  initCartMinOrder();
});

//Warranty and Package Protection Combined
const addProtectionsToCart = () => {
  const itemsToAdd = [];

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      if (
        document.querySelector('[data-shipping-protection-enabled="true"]') &&
        document.querySelector('[data-shipping-protection-auto-init="true"]')
      ) {
        const variantId = Number(
          document.querySelector("[data-shipping-protection-variant-id]").dataset.shippingProtectionVariantId
        );

        const isShippingProtectionInCart = cartData.items.some((item) => item.variant_id === variantId);

        if (!isShippingProtectionInCart) {
          itemsToAdd.push({
            quantity: 1,
            id: variantId,
          });
        }
      }

      if (
        document.querySelector('[data-warranty-protection-enabled="true"]') &&
        document.querySelector('[data-warranty-protection-auto-init="true"]')
      ) {
        const warrantyVariantId = Number(
          document.querySelector("[data-warranty-protection-variant-id]").dataset.warrantyProtectionVariantId
        );

        const isWarrantyProtectionInCart = cartData.items.some((item) => item.variant_id === warrantyVariantId);

        if (!isWarrantyProtectionInCart) {
          itemsToAdd.push({
            quantity: 1,
            id: warrantyVariantId,
          });
        }
      }

      if (itemsToAdd.length > 0) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: itemsToAdd }),
        })
          .then((response) => {
            window.refreshCartContents(response);
          })
          .catch((error) => console.error("Error adding protections:", error));
      }
    });
};

let previousCartItemCount = window.theme.cart.itemsCount || 0;

// document.addEventListener("DOMContentLoaded", () => {
//   fetch("/cart.js")
//     .then((response) => response.json())
//     .then((cartData) => {
//       previousCartItemCount = cartData.item_count;
//     });
// });

window.addEventListener("updated.ecomify.cart", () => {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      if (previousCartItemCount === 0 && cartData.item_count > 0) {
        addProtectionsToCart();
      }
      previousCartItemCount = cartData.item_count;
    });
});

window.onChangeCartShippingProtection = async (input) => {
  let response;

  if (input.checked) {
    response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: Number(input.value),
          },
        ],
      }),
    });
  } else {
    response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: input.dataset.lineItemKey,
        quantity: 0,
      }),
    });
  }
  window.refreshCartContents(response);
};

window.onChangeCartWarrantyProtection = async (input) => {
  let response;

  if (input.checked) {
    response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: Number(input.value),
          },
        ],
      }),
    });
  } else {
    response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: input.dataset.lineItemKey,
        quantity: 0,
      }),
    });
  }
  window.refreshCartContents(response);
};

const initCartCleanup = async () => {
  const unwantedProductIds = ["7180193693773", "7284390625357"];

  const response = await fetch("/cart.js");
  const cartData = await response.json();
  const cartItems = cartData.items;

  const unwantedItemsInCart = cartItems.filter((item) => unwantedProductIds.includes(String(item.product_id)));
  const otherItemsInCart = cartItems.filter((item) => !unwantedProductIds.includes(String(item.product_id)));

  if (unwantedItemsInCart.length > 0 && otherItemsInCart.length === 0) {
    for (const item of unwantedItemsInCart) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: item.key,
          quantity: 0,
        }),
      });
    }
    // Refresh the cart contents after removal
    window.refreshCartContents();
  }
};

window.addEventListener("updated.ecomify.cart", () => {
  initCartCleanup();
});

// Variant switcher
window.onChangeCartLineItemVariant = async (select) => {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: select.dataset.lineItemKey,
      quantity: 0,
    }),
  });

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [
        {
          quantity: Number(select.dataset.quantity),
          id: Number(select.value),
          selling_plan: select.dataset.sellingPlanId.length ? Number(select.dataset.sellingPlanId) : null,
        },
      ],
    }),
  });

  window.refreshCartContents(response);
};

// Terms checkbox
const initTermsCheckbox = () => {
  const checkbox = document.querySelector("#cart-terms-checkbox");

  if (!checkbox) return;

  const checkoutBtn = checkbox.closest("form").querySelector(".btn-checkout");
  checkoutBtn.disabled = true;

  checkbox.addEventListener("change", () => {
    if (checkbox.checked) {
      checkoutBtn.disabled = false;
    } else {
      checkoutBtn.disabled = true;
    }
  });
};
initTermsCheckbox();

window.addEventListener("updated.ecomify.cart", () => {
  initTermsCheckbox();
});

// Cart Discount
window.onCartDiscountClick = async (btn) => {
  const wrapper = document.querySelector("#cart-discount");

  btn.innerHTML = `
          <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
              <span class="visually-hidden">Loading...</span>
          </div>
      `;
  await fetch(`/discount/${wrapper.querySelector(".form-control").value}`);
  window.location.href = "/checkout";
};
